<template>
  <div class="simulation-result">
    <section class="simulation-confirmation">
      <div class="c-inner">
        <h2 class="c-heading">シミュレーション内容のご確認</h2>
        <div class="result-summary">
          <div class="result-summary__wrapper">
            <div class="result-summary__amount">
              <h3 class="result-summary__amount__heading">合計保険料</h3>
              <div class="result-summary__amount__body">
                <p class="c-price result-summary__amount__price">
                  {{ priceFormat(total) }}<span>円／月</span>
                </p>
                <div class="result-summary__pension">
                  <p class="result-summary__pension__title">積立年金</p>
                  <p class="result-summary__pension__price">
                    {{ priceFormat(totalTsumitate) }}<span>円</span>
                  </p>
                </div>
              </div>
            </div>
            <nav class="result-summary__link">
              <a @click="clickKlc()" class="result-summary__btn"
                >シミュレーション内容をKLCに送る</a
              >
            </nav>
          </div>
          <p class="result-summary__note">
            お申込みの際に下記シミュレーション内容を確認できると便利です。<br />メモ等にお控えいただくか、上のボタンよりKLCに送信してください。
          </p>
        </div>
        <div class="result-detail">
          <nav class="result-detail__nav">
            <ul class="result-detail__nav__list">
              <template v-for="person in persons" :key="person.ID">
                <li
                  class="result-detail__nav__item"
                  v-if="isInsuredPerson(person.ID)"
                >
                  <button
                    type="button"
                    :class="
                      'result-detail__nav__item__btn' + addHere(person.ID)
                    "
                    @click="changePerson(person.ID)"
                  >
                    {{ person.LABEL }}
                  </button>
                </li>
              </template>
            </ul>
          </nav>
          <div class="result-detail__body">
            <div class="result-detail-wrapper">
              <template v-for="person in persons" :key="person.ID">
                <template v-if="isInsuredPerson(person.ID)">
                  <div
                    class="result-detail-inner"
                    v-show="person.ID == currentPerson"
                  >
                    <ResultBody :pid="person.ID"></ResultBody>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="simulation-conversion">
      <a href="/entry" class="conversion-web" target="_blank"> WEB申込み </a>
      <a @click="clickKlc()" type="button" class="conversion-klc">
        KLCに相談
      </a>
    </section>
  </div>
  <button @click="move('options')" class="simulation-fixed-btn">
    前画面に<br />戻る
  </button>
</template>

<script>
import ResultBody from "./ResultBody.vue";
import {
  CRYPTO_PASSPHRASE,
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
} from "@/const.js";
import { mapGetters, mapMutations } from "vuex";
import crypto from "crypto-js";

export default {
  name: "TheResult",
  components: {
    ResultBody,
  },
  props: {},
  data() {
    return {
      currentPerson: "p1",
    };
  },
  computed: {
    ...mapGetters([
      "getPerson",
      "getPrice",
      "getOptionPrice",
      "getSubtotal",
      "getValueFromLabel",
      "isInsuredPerson",
      "isInsuredProduct",
      "priceFormat",
      "getFormValues",
    ]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    insuredPersons() {
      return this.persons.filter((p) => this.isInsuredPerson(p.ID));
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    insProducts() {
      return INS_PRODUCTS_LABELS;
    },
    productObj() {
      return (product) => {
        return this.insProducts.find((pro) => pro.ID === product);
      };
    },
    thePerson() {
      return (pid = this.currentPerson) => {
        return this.getPerson(pid);
      };
    },
    subtotalSeimei() {
      return this.getSubtotal("seimei", this.currentPerson);
    },
    subtotalSeikatsu() {
      return this.getSubtotal("seikatsu", this.currentPerson);
    },
    subtotalShushin() {
      return this.getSubtotal("shushin", this.currentPerson);
    },
    subtotalTsumitate() {
      return this.getSubtotal("tsumitate", this.currentPerson);
    },
    total() {
      // let sum = 0;
      // if (this.isInsuredProduct(this.currentPerson, "seimei")) {
      //   sum += this.subtotalSeimei;
      // }
      // if (this.isInsuredProduct(this.currentPerson, "seikatsu")) {
      //   sum += this.subtotalSeikatsu;
      // }
      // if (this.isInsuredProduct(this.currentPerson, "shushin")) {
      //   sum += this.subtotalShushin;
      // }
      return this.subtotalSeimei + this.subtotalSeikatsu + this.subtotalShushin;
    },
    totalTsumitate() {
      // let sum = 0;
      // if (this.isInsuredProduct(this.currentPerson, "tsumitate")) {
      //   sum += this.subtotalTsumitate;
      // }
      return this.subtotalTsumitate;
    },
    getSum() {
      return (product, pid = this.currentPerson) => {
        let sum = 0;
        this.productObj(product).CONDITIONS.forEach((con) => {
          if (con.OPTIONS === undefined) {
            // console.log(this.getPrice(
            //   product + "-" + con.ID,
            //   this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
            //   this.thePerson.age,
            //   this.getValueFromLabel(
            //     con.LABELS,
            //     this.thePerson.options[product][con.ID]
            //   )));
            // console.log(con);
            // console.log(this.thePerson(pid).options[product][con.ID]);
            sum += this.getPrice(
              product + "-" + con.ID,
              this.getValueFromLabel(GENDER_LABELS, this.thePerson(pid).gender),
              this.thePerson(pid).age,
              this.getValueFromLabel(
                product + "-" + con.ID === "seimei-course" &&
                  (pid === "p3" || pid === "p4")
                  ? con.LABELS_CHILD
                  : con.LABELS,
                this.thePerson(pid).options[product][con.ID]
              ),
              pid
            );
          } else {
            let values = [];
            con.OPTIONS.forEach((option) => {
              // console.log(
              //   this.thePerson(pid).options[product][con.ID][option.ID]
              // );
              values.push(
                this.getValueFromLabel(
                  option.LABELS,
                  this.thePerson(pid).options[product][con.ID][option.ID]
                )
              );
            });
            if (values.filter((v) => !!v).length === values.length) {
              sum += this.getOptionPrice(
                product + "-" + con.ID,
                this.getValueFromLabel(
                  GENDER_LABELS,
                  this.thePerson(pid).gender
                ),
                this.thePerson(pid).age,
                values
              );
            }
          }
        });
        return sum;
      };
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
    addHere(pid) {
      return pid === this.currentPerson ? " --here" : "";
    },
    changePerson(pid) {
      this.currentPerson = pid;
    },
    clickContact() {
      // this.insuredPersons.forEach((person) => {
      //   this.$store.commit("updateTotal", {
      //     personId: person.ID,
      //     subtotalSeimei: this.getSum("seimei", person.ID),
      //     subtotalSeikatsu: this.getSum("seikatsu", person.ID),
      //     subtotalShushin: this.getSum("shushin", person.ID),
      //     subtotalTsumitate: this.getSum("tsumitate", person.ID),
      //   });
      // });
      this.move("contact");
    },
    clickKlc() {
      // console.log(JSON.stringify(this.getFormValues));
      // this.insuredPersons.forEach((person) => {
      //   this.$store.commit("updateTotal", {
      //     personId: person.ID,
      //     subtotalSeimei: this.getSum("seimei", person.ID),
      //     subtotalSeikatsu: this.getSum("seikatsu", person.ID),
      //     subtotalShushin: this.getSum("shushin", person.ID),
      //     subtotalTsumitate: this.getSum("tsumitate", person.ID),
      //   });
      // });
      // let form = document.createElement("form");
      // form.action = "/contact/init";
      // form.method = "POST";
      // form.method = "POST";
      // document.body.append(form);
      // // formdata イベントに関数を登録(submit する直前に発火)
      // form.addEventListener("formdata", (e) => {
      //   let fd = e.formData;
      //   // データをセット
      //   fd.set("simulation", JSON.stringify(this.getFormValues));
      // });
      // form.submit();
      const salt = crypto.lib.WordArray.random(128);
      const iv = crypto.lib.WordArray.random(16);
      const key = crypto.PBKDF2(CRYPTO_PASSPHRASE, salt, {
        hasher: crypto.algo.SHA512,
        iterations: 100,
        keySize: 8,
      });
      const cipher = crypto.AES.encrypt(
        JSON.stringify(this.getFormValues),
        key,
        { iv: iv }
      );
      const encrypted = {
        a: crypto.enc.Base64.stringify(cipher.ciphertext),
        b: crypto.enc.Hex.stringify(salt),
        c: crypto.enc.Hex.stringify(iv),
      };
      document.cookie = "simulation=" + JSON.stringify(encrypted) + "; Max-Age=10; SameSite=Strict;Secure";
      window.location.href = "/contact/init";
    },
  },
};
</script>

<style scoped lang="scss">
.simulation {
  &-confirmation {
    background-color: $color-bg-main;
  }
  &-conversion {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
    background-color: rgba(0, 92, 131, 0.85);
    @include pc {
      height: 90px;
    }
    @include sp {
      height: 100px;
      padding: 0 16px;
    }
  }
  &-fixed-btn {
    position: fixed;
    display: block;
    background-color: rgba(230, 0, 18, 0.85);
    color: #fff;
    font-weight: 800;
    @include pc {
      bottom: 150px;
      right: calc((100% - $width-app-pc) / 2 - 100px);
      padding: 40px;
      border-radius: 10px;
    }
    @include sp {
      bottom: 110px;
      right: 0;
      padding: 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      @include font-size(12px);
    }
  }
}
.result {
  &-summary {
    background-color: $color-blue;
    color: #fff;
    @include pc {
      padding: 25px;
    }
    @include sp {
      padding: 13px;
    }
    &__wrapper {
      @include pc {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__amount {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include pc {
        width: 330px;
      }
      &__heading {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #fff;
        @include pc {
          width: 136px;
          height: 80px;
          font-size: 14px;
        }
        @include sp {
          width: 110px;
          height: 64px;
          font-size: 12px;
        }
      }
      &__body {
        text-align: right;
        @include pc {
          width: 180px;
        }
      }
      &__price {
        padding: 0 10px;
      }
    }
    &__link {
      @include sp {
        margin: 20px 0;
      }
    }
    &__pension {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      color: $color-blue;
      border-radius: 5px;
      height: 24px;
      padding: 0 10px;
      &__title {
        &:before {
          content: "+";
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          background-color: $color-blue;
          color: #fff;
          border-radius: 9999px;
          margin-right: 5px;
        }
      }
      &__price {
        font-weight: 800;
        font-size: 20px;
        line-height: 1;
        span {
          font-weight: normal;
          font-size: 15px;
        }
      }
    }
    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-red;
      color: #fff;
      font-weight: 800;
      text-align: center;
      border-radius: 7px;
      @include pc {
        width: 320px;
        height: 50px;
      }
      @include sp {
        width: 100%;
        height: 40px;
      }
    }
    &__note {
      text-align: center;
      line-height: 1.4;
      font-size: 12px;
      @include pc {
        margin-top: 20px;
      }
      @include sp {
        text-align: left;
      }
    }
  }
  &-detail {
    @include pc {
      margin: 40px 0;
    }
    @include sp {
      margin: 20px 0;
    }
    &__nav {
      &__list {
        display: flex;
        justify-content: flex-start;
        @include pc {
          gap: 15px;
        }
        @include sp {
          gap: 8px;
        }
      }
      &__item {
        @include pc {
          width: calc((100% - 15px * 3) / 4);
        }
        @include sp {
          width: calc((100% - 8px * 3) / 4);
        }
        &__btn {
          height: 35px;
          background-color: $color-bg-footer;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          font-weight: 800;
          font-size: 12px;
          width: 100%;
          &.--here {
            background-color: $color-text;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
    &__body {
      background-color: #fff;
      @include pc {
        padding: 50px 75px;
      }
      @include sp {
        padding: 30px 13px;
      }
    }
    // &__block {
    //   @include pc {
    //     margin-bottom: 70px;
    //   }
    //   @include sp {
    //     margin-bottom: 50px;
    //   }
    //   &:last-of-type {
    //     margin-bottom: 0;
    //   }
    // }
    // &__heading {
    //   font-weight: 800;
    //   font-size: 20px;
    //   .--seimei & {
    //     color: $color-seimei;
    //   }
    //   .--seikatsu & {
    //     color: $color-seikatsu;
    //   }
    //   .--shushin & {
    //     color: $color-shushin;
    //   }
    //   .--tsumitate & {
    //     color: $color-tsumitate;
    //   }
    // }
    // &__fee {
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   height: 52px;
    //   padding: 0 18px;
    //   margin-top: 25px;
    //   &__title {
    //     color: $color-text;
    //     font-size: 12px;
    //   }
    //   .--seimei & {
    //     color: $color-seimei;
    //     background-color: $color-seimei-bg;
    //   }
    //   .--seikatsu & {
    //     color: $color-seikatsu;
    //     background-color: $color-seikatsu-bg;
    //   }
    //   .--shushin & {
    //     color: $color-shushin;
    //     background-color: $color-shushin-bg;
    //   }
    //   .--tsumitate & {
    //     color: $color-tsumitate;
    //     background-color: $color-tsumitate-bg;
    //   }
    // }
    // &__item {
    //   border-bottom: 1px solid $color-bg-footer;
    //   margin-top: 15px;
    // }
    // &__dl {
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    // }
    // &__dt {
    //   font-weight: 800;
    //   font-size: 14px;
    //   .--seimei & {
    //     color: $color-seimei;
    //   }
    //   .--seikatsu & {
    //     color: $color-seikatsu;
    //   }
    //   .--shushin & {
    //     color: $color-shushin;
    //   }
    //   .--tsumitate & {
    //     color: $color-tsumitate;
    //   }
    // }
    // &__dd {
    //   font-size: 14px;
    // }
    // &__edit {
    //   text-decoration: underline;
    //   text-align: right;
    //   margin-top: 10px;
    //   font-size: 12px;
    //   &:hover {
    //     cursor: pointer;
    //     opacity: 0.7;
    //   }
    // }
  }
}
.conversion {
  &-web,
  &-klc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 800;
    border-radius: 7px;
    line-height: 1.2;
    @include pc {
      width: 230px;
      height: 50px;
    }
    @include sp {
      width: 100%;
      height: 68px;
    }
  }
  &-web {
    color: #fff;
    background-color: $color-red;
    font-size: 20px;
  }
  &-klc {
    color: $color-orange;
    background-color: #fff;
    font-size: 18px;
    @include pc {
    }
  }
}
</style>